import React, { useState } from 'react';
import { CheckCircle2Icon, ChevronDownIcon, GitMergeIcon } from 'lucide-react';
import { SlideToConfirm } from '../../ui/SlideToConfirm';
import { useDb } from '../../../hooks/useDb';
import { db } from '../../../utils/db';
import { contactById } from '../../../utils/dbSelectors';
export function DiffBody({
  onOpenGithub
}: {
  onOpenGithub: () => void;
}) {
  const {
    pr,
    files
  } = useDb(t => ({
    pr: t.pullRequests[0],
    files: t.diffs.filter(d => d.prId === t.pullRequests[0].id)
  }));
  const [open, setOpen] = useState<string[]>([files[0]?.path]);
  const add = pr.files.reduce((s, f) => s + f.additions, 0);
  const del = pr.files.reduce((s, f) => s + f.deletions, 0);
  return <div data-id="element-776" data-mp="1r3l7nkl3ixzn">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2" data-id="element-777" data-mp="1r3uzzetm5h8i">
        <span className="font-mono text-[13px] text-ink-muted" data-id="element-778" data-mp="1m3fokssw6jt6">{pr.branch}</span>
        <span className="tabular-nums text-ink" data-id="element-779" data-mp="1m5jnsxfuiun4">
          <span className="text-positive" data-id="element-780" data-mp="1h5nmj5yj9hb9">+{add}</span> <span className="text-negative" data-id="element-781" data-mp="1h6ynky0lgayo">−{del}</span> · {pr.files.length} bestanden
        </span>
        <span className="flex items-center gap-1.5 text-positive" data-id="element-782" data-mp="poqfv7qlg9xo">
          <CheckCircle2Icon className="h-4 w-4" aria-hidden data-id="element-783" data-mp="uiuodvficq0v" /> {pr.tests.passed}/{pr.tests.passed + pr.tests.failed} tests geslaagd
        </span>
        {pr.status === 'goedgekeurd' && <span className="text-accent" data-id="element-784" data-mp="kqouuh9ly0jk">Review goedgekeurd</span>}
      </div>
      <div className="mt-4 overflow-hidden rounded-2xl border border-white/[0.07] bg-night-950/60" data-id="element-785" data-mp="18hc9dle13of3">
        {files.map(f => {
        const isOpen = open.includes(f.path);
        const meta = pr.files.find(x => x.path === f.path);
        return <div key={f.path} className="border-b border-white/[0.06] last:border-b-0" data-id="element-786" data-mp="yimwy84wiw68">
              <button type="button" aria-expanded={isOpen} onClick={() => setOpen(o => isOpen ? o.filter(p => p !== f.path) : [...o, f.path])} className="flex w-full items-center gap-3 px-4 py-2.5 text-left transition-colors duration-150 hover:bg-white/[0.03]" data-id="element-787" data-mp="13getxgkel8ha">
                <ChevronDownIcon className={`h-4 w-4 text-ink-muted transition-transform duration-150 ${isOpen ? '' : '-rotate-90'}`} aria-hidden data-id="element-788" data-mp="1pqn3bwfoineb" />
                <span className="min-w-0 flex-1 truncate font-mono text-[13px] text-ink" data-id="element-789" data-mp="1ky3tnak44ces">{f.path}</span>
                <span className="font-mono text-[13px] tabular-nums" data-id="element-790" data-mp="1g0bqtlhxj5vt">
                  <span className="text-positive" data-id="element-791" data-mp="1b2jxqo5jtdq1">+{meta?.additions}</span> <span className="text-negative" data-id="element-792" data-mp="16zx20c5rb8nk">−{meta?.deletions}</span>
                </span>
              </button>
              {isOpen && <div className="overflow-x-auto pb-2 font-mono text-[13px] leading-6" data-id="element-793" data-mp="121ltc4r7746x">
                  <p className="px-4 text-ink-muted" data-id="element-794" data-mp="x2rch8csjppg">{f.hunk}</p>
                  {f.lines.map((l, i) => <div key={i} className={`flex whitespace-pre ${l.type === 'add' ? 'bg-positive/10 text-positive-soft' : l.type === 'del' ? 'bg-negative/10 text-negative-soft' : 'text-ink-soft'}`} data-id="element-795" data-mp="2wdipgb0l4y8b" data-mpi={i}>
                      <span className="w-12 shrink-0 select-none pr-3 text-right text-ink-muted" data-id="element-796" data-mp="33y2zhv78pok9">{l.n}</span>
                      <span className="w-4 shrink-0 select-none" data-id="element-797" data-mp="38ojirvxqs4ej">{l.type === 'add' ? '+' : l.type === 'del' ? '−' : ' '}</span>
                      <span data-id="element-798" data-mp="3dmuru4g7qavp">{l.text}</span>
                    </div>)}
                </div>}
            </div>;
      })}
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-3" data-id="element-799" data-mp="2kyp3z8tv45rn">
        <p className="flex items-center gap-2 text-ink" data-id="element-800" data-mp="2l1bkhxyqdvm0">
          <GitMergeIcon className="h-4 w-4 text-ink-muted" aria-hidden data-id="element-801" data-mp="2pxsbczxbeo2s" /> Mergen doe je zelf.
        </p>
        <button type="button" onClick={onOpenGithub} className="ml-auto h-10 whitespace-nowrap rounded-full border border-white/10 px-4 text-[14px] font-medium text-ink transition-colors duration-150 hover:border-white/25" data-id="element-802" data-mp="2uz99wosbtyg7">
          Open in GitHub
        </button>
      </div>
    </div>;
}
export function SlackBody({
  onPosted
}: {
  onPosted: () => void;
}) {
  const {
    msg,
    contact
  } = useDb(t => {
    const m = t.slackMessages[0];
    return {
      msg: m,
      contact: contactById(t, m.contactId)
    };
  });
  return <div data-id="element-803" data-mp="cs53orm3mg55">
      <div className="rounded-2xl bg-white/[0.04] p-4" data-id="element-804" data-mp="crc368dqgmvg">
        <p className="text-[13px] text-ink-muted" data-id="element-805" data-mp="ctydugvx7ihw">
          {contact?.name} · {msg.channel} · {msg.time}
        </p>
        <p className="mt-1 text-ink" data-id="element-806" data-mp="mq1chcrkcz03">{msg.text}</p>
      </div>
      {msg.status === 'open' ? <div className="mt-4 flex gap-2" data-id="element-807" data-mp="10hg8ck6kkuok">
          <button type="button" onClick={() => db.setSlack(msg.id, 'concept')} className="h-11 whitespace-nowrap rounded-full bg-ink px-5 text-[14px] font-semibold text-night-950 transition-colors duration-150 hover:bg-white" data-id="element-808" data-mp="10gellig6yjr0">
            Ja, bereid voor
          </button>
        </div> : <div className="mt-4" data-id="element-809" data-mp="15epwlwi830at">
          <p className="text-[13px] font-medium text-ink-muted" data-id="element-810" data-mp="1p1t5bjptatgt">Concept-antwoord van Anna</p>
          <p className="mt-1 border-l-2 border-accent/50 pl-3 text-ink" data-id="element-811" data-mp="1t4fypp24smg4">{msg.draftReply}</p>
          <div className="mt-4" data-id="element-812" data-mp="1f4ex27e1lazl">
            {msg.status === 'geplaatst' ? <p className="flex items-center gap-2 text-accent" data-id="element-813" data-mp="1f6iy8hkk3vw6">
                <CheckCircle2Icon className="h-4 w-4" aria-hidden data-id="element-814" data-mp="1k1oizd2834io" /> Geplaatst in {msg.channel}
              </p> : <SlideToConfirm label="Schuif om te plaatsen" confirmedLabel="Geplaatst" onConfirm={() => {
          db.setSlack(msg.id, 'geplaatst');
          onPosted();
        }} data-id="element-815" data-mp="15cilpumy3odf" />}
          </div>
        </div>}
    </div>;
}
export function MailBody({
  onSent
}: {
  onSent: () => void;
}) {
  const {
    draft,
    original,
    proposal
  } = useDb(t => {
    const d = t.mailDrafts.find(x => x.id === 'd-bakker-reply');
    return {
      draft: d,
      original: t.mails.find(m => m.id === d?.mailId),
      proposal: t.proposals.find(p => p.id === 'p-mail-bakker')
    };
  });
  if (!draft) return null;
  const done = proposal?.status === 'goedgekeurd';
  return <div data-id="element-816" data-mp="3upthuqkuu7yn">
      <dl className="grid grid-cols-[80px_1fr] gap-y-1 text-[14px]" data-id="element-817" data-mp="3unfoqn9qj5tq">
        <dt className="text-ink-muted" data-id="element-818" data-mp="3prrxm2bp02ll">Aan</dt>
        <dd className="text-ink" data-id="element-819" data-mp="r8teu45t8nhr">klant Bakker</dd>
        <dt className="text-ink-muted" data-id="element-820" data-mp="r7ideazu7rtt">Onderwerp</dt>
        <dd className="text-ink" data-id="element-821" data-mp="m9qjjbfmtvmz">{draft.subject}</dd>
      </dl>
      <p className="mt-4 text-[13px] font-medium text-accent" data-id="element-822" data-mp="mai5dujfgf02">Geschreven door Anna</p>
      <p className="mt-1 border-l-2 border-accent/50 pl-3 text-ink" data-id="element-823" data-mp="h9cem29bv1t6">{draft.body}</p>
      {original && <>
          <p className="mt-4 text-[13px] font-medium text-ink-muted" data-id="element-824" data-mp="cbapp0p8089s">Origineel · {original.received}</p>
          <p className="mt-1 border-l-2 border-white/15 pl-3" data-id="element-825" data-mp="31yrz6fhyduad">{original.snippet}</p>
        </>}
      <div className="mt-5" data-id="element-826" data-mp="2x3w5zc0zd0vo">
        {done ? <p className="flex items-center gap-2 text-accent" data-id="element-827" data-mp="1ckimkkw9vw1e">
            <CheckCircle2Icon className="h-4 w-4" aria-hidden data-id="element-828" data-mp="1hitu2oz3hugg" /> Verstuurd
          </p> : <SlideToConfirm label="Schuif om te versturen" confirmedLabel="Verstuurd" onConfirm={() => {
        db.approveProposal('p-mail-bakker');
        onSent();
      }} data-id="element-829" data-mp="1mhx0oduq48qj" />}
      </div>
    </div>;
}